import type { IntlShape } from 'react-intl';

/**
 * Formats a rating value to one decimal place using the intl locale.
 * @param rating Numeric rating (e.g. 4.7)
 * @param intl react-intl instance (locale comes from IntlProvider)
 * @returns Formatted string (e.g. "4.7" in en-US, "4,7" in de-DE)
 */
export const ratingToFormattedRating = (rating: number, intl: IntlShape): string =>
  intl.formatNumber(rating, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
